import { forwardRef } from 'react';
import { v4 as uuid } from 'uuid';

import SvgIcon from 'shell/components/SvgIcon';

export default forwardRef((props, ref) => {
    const id = uuid();

    return (
        <SvgIcon ref={ref} {...props}>
            <g clipPath={`url(#${id})`}>
                <path d='M12 0C5.376 0 0 5.376 0 12C0 18.624 5.376 24 12 24C18.624 24 24 18.624 24 12C24 5.376 18.624 0 12 0ZM12 21.6C6.708 21.6 2.4 17.292 2.4 12C2.4 6.708 6.708 2.4 12 2.4C17.292 2.4 21.6 6.708 21.6 12C21.6 17.304 17.292 21.6 12 21.6ZM17.868 14.952C16.656 21.12 7.33201 20.988 6.12001 14.832C5.97601 14.112 6.576 13.704 7.308 13.704H7.33198C7.90798 13.704 8.376 13.992 8.508 14.544C9.336 18.048 14.664 17.928 15.492 14.424C15.624 13.872 16.092 13.704 16.668 13.704H16.692C17.412 13.704 18.012 14.232 17.868 14.952ZM8.4 12.504H6C5.34 12.504 4.8 11.964 4.8 11.304C4.8 11.232 4.8 8.844 4.8 8.904C4.8 8.244 5.34 7.704 6 7.704H8.4C9.06 7.704 9.6 8.244 9.6 8.904C9.6 8.952 9.6 11.328 9.6 11.304C9.6 11.964 9.06 12.504 8.4 12.504ZM19.2 8.904C19.2 8.952 19.2 11.328 19.2 11.304C19.2 11.964 18.66 12.504 18 12.504H15.6C14.94 12.504 14.4 11.964 14.4 11.304C14.4 11.232 14.4 8.844 14.4 8.904C14.4 8.244 14.94 7.704 15.6 7.704H18C18.66 7.704 19.2 8.244 19.2 8.904Z' />
            </g>
            <defs>
                <clipPath id={id}>
                    <rect width='24' height='24' />
                </clipPath>
            </defs>
        </SvgIcon>
    );
});
